import script from "./dayOverviewSimple.vue?vue&type=script&setup=true&lang=js"
export * from "./dayOverviewSimple.vue?vue&type=script&setup=true&lang=js"

import "./dayOverviewSimple.vue?vue&type=style&index=0&id=2a24dac5&scoped=true&lang=scss"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a24dac5"]])

export default __exports__